import { render, staticRenderFns } from "./pointDuiAllDetailList.vue?vue&type=template&id=1c192286&"
import script from "./pointDuiAllDetailList.vue?vue&type=script&lang=js&"
export * from "./pointDuiAllDetailList.vue?vue&type=script&lang=js&"
import style0 from "./pointDuiAllDetailList.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports